import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { useGetPendingSignatureMedicationsQuery } from "app/services/api/medicationsApi";
import { MedicationIndexPaginatedResponse } from "app/services/api/types/medications/responses/MedicationIndexResponse";
import { RootState } from "app/services/store";
import { selectResidentPendingSignatureMedications } from "app/store/slices/medications";
import { selectIsOnline } from "app/store/slices/network";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import usePagination from "ui/molecules/pagination/usePagination";

export function usePendingMedicationSignatureWithOffline() {
  const { residentId } = useResidentContext();
  const { handlePageChange, currentPage } = usePagination();
  const isOnline = useSelector(selectIsOnline);

  const offlineData = useSelector((state: RootState) =>
    selectResidentPendingSignatureMedications(state, residentId),
  );

  const {
    data: onlineData,
    isFetching,
    isError,
  } = useGetPendingSignatureMedicationsQuery(
    { filter: { resident_id: residentId }, page: currentPage },
    { skip: !residentId },
  );

  const data = useMemo(() => {
    if (isFetching || isOnline) return (onlineData as MedicationIndexPaginatedResponse)?.data;
    if (isError && offlineData) return offlineData;
    return (onlineData as MedicationIndexPaginatedResponse)?.data;
  }, [onlineData, offlineData, isOnline, isFetching]);

  return { data, meta: (onlineData as MedicationIndexPaginatedResponse)?.meta, isFetching, handlePageChange };
}
